import DataTable from "@/components/data-table";
import Spinner from "@/components/Spinner";
import { Card, CardContent } from "@/components/ui/card";
import { memo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { QueryTable } from "@/components/query-table/QueryTable";
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from "@/components/ui/resizable";
import { SuccessFetchListResponse } from "@/services/api";
import { useDataTableQuery } from "@/components/data-table/hooks/useDataTableQuery";
import { ProjectSchedulesTable } from "@/modules/projects/components/schedules/ProjectSchedulesTable";
import { ReadProjectSchedule } from "@/types/projectSchedule";
import { useSyncTableRowHover } from "@/modules/projects/hooks/useSyncTableRowHover";

const ProjectScheduleListContentComponent = () => {
  const { t } = useTranslation();
  const { query } =
    useDataTableQuery<SuccessFetchListResponse<ReadProjectSchedule>>();

  const storesTableContainerRef = useRef<HTMLDivElement | null>(null);
  const schedulesTableContainerRef = useRef<HTMLDivElement | null>(null);

  const { onTableHover, onTableLeave } = useSyncTableRowHover(
    storesTableContainerRef,
    schedulesTableContainerRef,
  );

  return (
    <>
      <ResizablePanelGroup
        direction="horizontal"
        className="gap-2"
        autoSaveId="project-schedules"
      >
        <ResizablePanel>
          <Card>
            <CardContent className="gap-2 p-2 justify-between relative grow">
              <div className="flex flex-col gap-2 border min-h-32 mb-2 h-full">
                {query.isPending || query.isLoading ? (
                  <Spinner
                    className="h-full w-full grow"
                    label={t("table.loading")}
                  />
                ) : (
                  <DataTable
                    ref={storesTableContainerRef}
                    onRowMouseEnter={onTableHover}
                    onRowMouseLeave={onTableLeave}
                  />
                )}
              </div>
              <QueryTable.Status />
            </CardContent>
          </Card>
        </ResizablePanel>
        <ResizableHandle withHandle />
        <ResizablePanel>
          <Card>
            <CardContent className="gap-2 p-2 justify-between relative grow">
              <div className="flex flex-col gap-2 border min-h-32 mb-2 h-full">
                {query.isPending || query.isLoading ? (
                  <Spinner
                    className="h-full w-full grow"
                    label={t("table.loading")}
                  />
                ) : (
                  <ProjectSchedulesTable
                    ref={schedulesTableContainerRef}
                    onRowMouseEnter={onTableHover}
                    onRowMouseLeave={onTableLeave}
                  />
                )}
              </div>
            </CardContent>
          </Card>
        </ResizablePanel>
      </ResizablePanelGroup>
    </>
  );
};

export const ProjectScheduleListContent = memo(
  ProjectScheduleListContentComponent,
);
